module.exports = __webpack_public_path__ + "img/sjjh-bg.6f593bb3.png";